import React, {useEffect, useState} from 'react';
import Input from '../Input';
import CustomSelect from '../CustomSelect';
import {toast} from 'react-toastify';
import {validationEmail} from '../../global/validate';
import {useInviteFboMutation} from '../../store/builder/inspections.api';
import {setLoader} from '../../store/builder/reducer';
import {useDispatch} from 'react-redux';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useTranslation} from '../../hooks/useTranslation';

const FBOManagementModal = ({exit}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const [state, setState] = useState({
    fbo_name: null,
    email: null,
    has_corporate_settings: null,
  });

  const [
    invite,
    {
      isLoading: inviteIsLoading,
      isError: inviteIsError,
      error: inviteError,
      isSuccess: inviteIsSuccess,
    },
  ] = useInviteFboMutation();

  const [errorHandler, setErrorHandler] = useErrorHandler([inviteError]);

  useEffect(() => {
    if (inviteIsLoading) {
      dispatch(setLoader(true));
    }
    if (inviteIsSuccess) {
      dispatch(setLoader(false));
      toast.success(t('fboManagementModal.messages.inviteSuccess'));
      exit();
    }
    if (inviteIsError) {
      dispatch(setLoader(false));
      toast.error(inviteError?.data?.email[0]);
    }
  }, [inviteIsLoading, inviteIsSuccess, inviteIsError]);

  const handleChange = e => {
    setState(old => ({...old, [e.target.name]: e.target.value}));
  };

  const submit = e => {
    e.preventDefault();
    if (
      state?.fbo_name?.length > 0 &&
      validationEmail(state?.email) &&
      state?.has_corporate_settings !== null
    ) {
      invite({
        fbo_name: state.fbo_name,
        email: state.email,
        has_corporate_settings: state.has_corporate_settings,
        role_id: 2,
      });
    } else {
      toast.error(t('fboManagementModal.messages.fillAllFields'));
    }
  };

  return (
    <div className='modal modal-fbo'>
      <div className='modal__content'>
        <div className='modal__content-head'>
          <p>{t('fboManagementModal.title')}</p>
          <img
            className='modal__content-exit'
            src='/assets/icons/close.svg'
            alt='close'
            onClick={exit}
          />
        </div>
        <div className={`modal__content-body`}>
          <Input
            containerWidth={'100%'}
            id='fbo_name'
            name='fbo_name'
            placeholder={t('fboManagementModal.fboNamePlaceholder')}
            label={t('fboManagementModal.fboName')}
            type={'text'}
            onChange={handleChange}
            // defaultValue={currentItem ? currentItem?.title : ""}
          />
          <Input
            containerWidth={'100%'}
            id='email'
            name='email'
            placeholder={t('fboManagementModal.adminEmailPlaceholder')}
            label={t('fboManagementModal.adminEmail')}
            type={'text'}
            onChange={handleChange}
            // defaultValue={currentItem ? currentItem?.title : ""}
          />
          <CustomSelect
            label={t('fboManagementModal.standardizeSettings')}
            name={'has_corporate_settings'}
            onChange={handleChange}
            options={[
              {value: '1', label: t('fboManagementModal.defaultSettings')},
              {value: '0', label: t('fboManagementModal.customSettings')},
            ]}
          />
        </div>
        <div className='modal__content-bottom'>
          <button className='close' onClick={exit}>
            {t('fboManagementModal.close')}
          </button>
          <button className='save' onClick={submit}>
            {t('fboManagementModal.save')}
          </button>
        </div>
      </div>
      <div className='modal__bg'></div>
    </div>
  );
};

export default FBOManagementModal;
